import "./footer.css";

import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import React from "react";
import Row from "react-bootstrap/Row";
const imgCDNURL = process.env.REACT_APP_MORGANROCKS_CDN_URL;
const imgURL = process.env.REACT_APP_LIMITLESS_CDN_URL;
export default function Footer() {
  return (
    <>
      <footer className="topStrip">
        <Container className="move-content-text ">
          <Row>
            <Col className="imageclass d-flex text-align-center">
              {/* <Image
                fluid
                src="https://resources.swmc.com/swmc-images/Footer/equal-housing.png"
                className="hideBig"
              />
              <Image src={imgCDNURL + "eoe.svg"} className="eoeimage" /> */}
              <Image
                className="eoeimage"
                src="https://resources.swmc.com/swmc-images/Footer/equal-housing.png" alt="Equal Housing logo"
              />
            </Col>
          </Row>
          <Row className="pl-3 pr-2 pb-3 pt-2 text-center movecontent">
            <Col lg={12} className="mobiletextmove">
              <p className="footertext"></p>
              <p className="footertext">
                For licensing information, go to:{" "}
                <a
                  href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/company/3277"
                  target="_blank"
                  rel="noreferrer"
                  title="NMLS Consumer Access"
                  className="footerlink"
                >
                  www.nmlsconsumeraccess.org
                </a>{" "}
                <br />
                Visit{" "}
                <a
                  href="https://www.swmc.com/disclaimer"
                  target="_blank"
                  rel="noreferrer"
                  title="Click here for full list of license information of Sun West Mortgage Company, Inc."
                  className="footerlink"
                >
                  https://www.swmc.com/disclaimer
                </a>{" "}
                for the full list of license information.
              </p>

              <p className="footertext">
                Please{" "}
                <a
                  href="https://www.swmc.com/TXdis"
                  target="_blank"
                  rel="noreferrer"
                  title="View Texas Complaint Notice and Servicing Disclosure"
                  className="footerlink"
                >
                  Click Here
                </a>{" "}
                to view Texas Complaint Notice and Servicing Disclosure.
              </p>
              <div>
                <p className="footertext">
                  © {new Date().getFullYear()} Sun West Mortgage Company, Inc.
                  All Rights Reserved{" "}
                </p>
              </div>
              <p className="footertext">
                <a
                  href="https://www.swmc.com/privacy-policy"
                  rel="noopener noreferrer"
                  target="_blank"
                  title="Our Privacy Policy"
                  className="footerlink last"
                >
                  Privacy Policy
                </a>{" "}
                |{" "}
                <a
                  href="https://www.swmc.com/terms-and-conditions"
                  rel="noopener noreferrer"
                  target="_blank"
                  title="Our Terms & Conditions"
                  className="footerlink last"
                >
                  Terms and Conditions
                </a>{" "}
                |{" "}
                <a
                  href="https://www.swmc.com/disclaimer"
                  rel="noopener noreferrer"
                  target="_blank"
                  title="List of licenses information of Sun West Mortgage Company, Inc."
                  className="footerlink last"
                >
                  Licenses
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}
